module.exports = __webpack_public_path__ + "img/chart.acce3ef9.svg";